import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'
import PagedMixin from '@/common/pagination/mixins/paged-mixin'
import Stakeholder from '@/stakeholders/entities/stakeholder'

@Component
export default class StakeholdersTable extends Mixins(PagedMixin) {

  @Prop({ type: Boolean, default: false })
  public loading!: boolean

  @Prop({ default: () => [] })
  public stakeholders!: Stakeholder[]

  public options: any = {}

  get headers() {
    return [
      { text: 'Name', value: 'name' },
      { text: 'Funktion', value: 'role' },
      { text: 'Bundesland', value: 'region' },
      { text: 'Aktionen', value: 'action', sortable: false },
    ]
  }

  private edit(stakeholder: Stakeholder) {
    this.$emit('edit', stakeholder)
  }

  private deleteStakeholder(stakeholder: Stakeholder) {
    if (confirm('Soll der Stakeholder wirklich gelöscht werden?')) {
      this.$emit('delete', stakeholder)
    }
  }
}
